import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchProductOffers } from '~/services/product';

var ProductOffersModal = function ProductOffersModal() {
  return import(
  /* webpackMode: "eager" */
  '~/components/molecules/Product/Modal/ProductOffersModal.vue');
};

export default {
  name: 'ProductOffers',
  components: {
    ProductOffersModal: ProductOffersModal
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    offersTotal: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      showModal: false,
      modal: null,
      offers: null
    };
  },
  methods: {
    closeAction: function closeAction() {
      this.showModal = false;
      this.modal = null;
    },
    handleClick: function handleClick(event) {
      var _this = this;

      fetchProductOffers(this.$store, this.product.reference).then(function (_ref) {
        var offers = _ref.offers;
        _this.offers = offers;
        _this.modal = 'product-offers-modal';
        _this.showModal = true;

        _this.$root.$emit('generic-tracking', event, {
          data: {
            event_category: 'FicheProduit',
            event_action: 'Clic_offres',
            event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
          }
        });
      });
    }
  }
};